module.exports = __webpack_public_path__ + "images/schedule_profile_session.png";